const antiPassback = {
  title: 'Anti-passback',
  restriction_mode: {
    title: 'Mode de restriction',
    hard: 'Strict',
    soft: 'Souple',
    hard_helper: 'Refuse l’accès lorsqu’une violation de passback est détectée',
    soft_helper:
      'Enregistre la violation de passback mais accorde tout de même l’accès',
  },
  user_exit_reset: {
    title: 'Réinitialisation de la sortie utilisateur',
    delay_or_exit_reader: {
      title: 'Délai ou lecteur de sortie',
      description:
        'Réinitialisation lors du passage sur un lecteur périphérique, ou automatiquement après un délai.',
    },
    schedule_or_exit_reader: {
      title: 'Horaire ou lecteur de sortie',
      description:
        'Réinitialisation lors du passage sur un lecteur périphérique, ou aux heures planifiées.',
      info: 'La réinitialisation se fait au début de l’horaire.',
    },
    exit_reader_only: {
      title: 'Lecteur de sortie UNIQUEMENT',
      description:
        'L’emplacement de l’utilisateur n’est réinitialisé que lorsque la carte est présentée à un lecteur périphérique.',
      warning: 'Sélectionnez au moins une porte avec un lecteur de sortie.',
    },
  },
  exempted_users: {
    title: 'Utilisateurs exemptés',
    description:
      'Les utilisateurs sélectionnés sont exemptés de l’application de l’Anti-passback.',
  },
  peripheral_doors: {
    title: 'Portes périphériques',
    description:
      'Les portes sélectionnées appliqueront le paramètre Anti-passback lorsqu’il est activé.',
  },
  validation: {
    must_be_number: 'Doit être un nombre',
    must_be_integer: 'Doit être un entier',
    must_be_at_least: 'Doit être au moins {{min}}',
    must_be_at_most: 'Doit être au plus {{max}}',
  },
  not_supported: {
    title: 'Fonctionnalité non prise en charge',
    description:
      'Le micrologiciel du contrôleur maître doit être en version {{ minVersion }} ou supérieure pour utiliser l’Anti-passback. Mettez à jour le micrologiciel du contrôleur maître pour accéder à cette fonctionnalité.',
  },
  firmware_requirement: 'Exigence de firmware',
};

export default antiPassback;
